import React, { Component } from "react";
import '../youtube.css';

const CHANNEL_URL = "https://www.youtube.com/channel/UCcJFuKnfXn8IKKuzUBebE_w";
// Uploads playlist ID = channel ID with "UC" replaced by "UU"
const UPLOADS_PLAYLIST = "UUcJFuKnfXn8IKKuzUBebE_w";
const EMBED_URL = `https://www.youtube.com/embed/videoseries?list=${UPLOADS_PLAYLIST}&rel=0&modestbranding=1`;

export class YouTubeFeature extends Component {
  render() {
    return (
      <div id="youtube" className="yt-section">
        <div className="container">
          <div className="yt-header">
            <span className="yt-eyebrow">
              <i className="fa fa-youtube-play"></i> Watch on YouTube
            </span>
            <h2>Lesson On Golf — Video</h2>
            <p className="yt-sub">
              Pro pointers, equipment reviews, travel and the best places to play —
              all on the Lesson On Golf YouTube channel.
            </p>
          </div>

          <div className="yt-content">
            <div className="yt-player-wrap">
              <iframe
                className="yt-player"
                src={EMBED_URL}
                title="Lesson On Golf YouTube"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>

            <div className="yt-cta-card">
              <div className="yt-cta-logo">
                <i className="fa fa-youtube-play"></i>
              </div>
              <h3>Subscribe to our channel</h3>
              <p>
                Never miss an episode — get the latest videos delivered straight
                to your feed.
              </p>
              <a
                href={CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="yt-btn"
              >
                <i className="fa fa-youtube-play"></i>
                Visit the Channel
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default YouTubeFeature;
